import {
  MODIFY_INCENTIVE,
  COMPLETE_ADD_MANY_INCENTIVES,
  START_ADD_MANY_INCENTIVES,
  FINISH_ADD_MANY_INCENTIVES,
  START_ADD_MANY_INCENTIVES_REQUEST
} from '../actions';

const initialState = {
  addedIncentives:    [],
  errors:             undefined,
  error_record:       undefined,
  creatingIncentives: false,
  saving:             false
};

const addIncentiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODIFY_INCENTIVE: {
      const { incentive } = action;
      return {
        ...state,
        ...incentive
      };
    }
    case START_ADD_MANY_INCENTIVES: {
      return {
        ...state,
        creatingIncentives: true
      };
    }
    case FINISH_ADD_MANY_INCENTIVES: {
      return {
        ...state,
        creatingIncentives: false
      };
    }
    case START_ADD_MANY_INCENTIVES_REQUEST: {
      return {
        ...state,
        saving: true
      };
    }
    case COMPLETE_ADD_MANY_INCENTIVES: {
      const { response } = action;
      const { data } = response;
      if (data.error_record) {
        return {
          ...initialState,
          creatingIncentives: true,
          saving:             false,
          ...data
        };
      } else {
        return {
          ...initialState,
          creatingIncentives: true, // dont close out the form just because the request is done
          saving:             false,
          addedIncentives:    data.provider_incentive_costs
        };
      }
    }
    default: {
      return state;
    }
  }
};

export default addIncentiveReducer;
